/**
 * Vorschauspalte im gestapelten Galerie-Layout ("Raster").
 *
 * Dort liegen alle Produktbilder untereinander. Horizon rendert in diesem
 * Layout keine Vorschaubilder — es ist ja ohnehin alles sichtbar. Nach dem
 * Vorbild von blackblaze werden sie hier selbst aufgebaut: eine schmale Spalte
 * links, die stehen bleibt und der Scrollposition folgt. Das gerade sichtbare
 * Bild ist voll deckend, die übrigen treten zurück.
 *
 * Welches Bild gerade zu sehen ist, meldet ein IntersectionObserver — eine
 * Meldung pro Wechsel statt einer pro gescrolltem Pixel. Das bleibt auch auf
 * schwachen Geräten flüssig.
 *
 * Im Karussell-Layout tut die Datei nichts: Dort gibt es nur ein sichtbares
 * Bild, und Horizons eigene Vorschauspalte ist vorhanden.
 */
(function () {
  'use strict';

  function start() {
    // Nur am Desktop: Unterhalb 1100px laeuft die Galerie als
    // Wisch-Karussell. Dort nimmt die Vorschauspalte nur Platz, und ihr
    // Einfuegen stoert die Stelle, an der der Konfigurator seine Vorschau
    // ablegt. Das zugehoerige CSS war laengst begrenzt, das Skript nicht.
    if (!window.matchMedia('(min-width: 1100px)').matches) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    // Im Raster-Layout sind die Bilder Listeneintraege in .media-gallery__grid.
    // Die slideshow-slide-Elemente gehoeren zum Karussell, das dort unsichtbar
    // mitlaeuft - genau darauf hatte ich zuerst gehoert und deshalb die
    // falschen Elemente beobachtet.
    var raster = gallery.querySelector('.media-gallery__grid');

    // Nur im Raster-Layout. Im Karussell gibt es ein Hauptbild und Horizons
    // eigene Steuerung - das Markieren von Vorschaubildern greift dort in
    // fremde Logik ein und laesst das Hauptbild aufblitzen.
    if (!raster) return;
    var slides = raster
      ? raster.querySelectorAll(':scope > li')
      : gallery.querySelectorAll('slideshow-slide, .slideshow-slide');
    if (slides.length < 2) return;

    // Horizon rendert die Vorschaubilder auch im gestapelten Layout, blendet
    // sie dort aber per CSS aus. Sie werden also wiederverwendet statt neu
    // gebaut - eine frühere Fassung baute eine eigene Spalte und brach hier ab,
    // weil sie das vorhandene Markup als Karussell deutete.
    var vorhandene = raster ? [] : gallery.querySelectorAll('.slideshow-controls__thumbnail');

    var spalte = gallery.querySelector('.rxk-thumbs');
    if (!spalte && !vorhandene.length) {
      spalte = document.createElement('div');
      spalte.className = 'rxk-thumbs';

      for (var n = 0; n < slides.length; n++) {
        var quelle = slides[n].querySelector('img');
        if (!quelle) continue;

        var knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'rxk-thumb';
        knopf.setAttribute('aria-label', 'Bild ' + (n + 1));

        var bild = document.createElement('img');
        bild.src = quelle.currentSrc || quelle.src;
        bild.alt = '';
        bild.loading = 'lazy';

        knopf.appendChild(bild);
        spalte.appendChild(knopf);
      }

      if (!spalte.children.length) return;
      gallery.insertBefore(spalte, gallery.firstChild);
    }

    var thumbs = vorhandene.length ? vorhandene : spalte.querySelectorAll('.rxk-thumb');

    // Die Vorschau des Konfigurators liegt im ersten Rasterbild. Sie darf nicht
    // in die Vorschauspalte kopiert werden - dort waere sie sinnlos und wuerde
    // beim Plattenwechsel veralten.
    var kopie = spalte && spalte.querySelector('.rxk-preview-box');
    if (kopie) kopie.remove();
    gallery.classList.add('rxk-gallery-scroll');

    function markiere(index) {
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.toggle('rxk-thumb--aktiv', i === index);
      }
    }

    markiere(0);

    var beobachter = new IntersectionObserver(
      function (eintraege) {
        // Beim Scrollen sind kurz zwei Bilder gleichzeitig im Blick — das mit
        // dem größeren sichtbaren Anteil gewinnt.
        var beste = null;
        for (var i = 0; i < eintraege.length; i++) {
          if (!eintraege[i].isIntersecting) continue;
          if (!beste || eintraege[i].intersectionRatio > beste.intersectionRatio) {
            beste = eintraege[i];
          }
        }
        if (!beste) return;

        var index = Array.prototype.indexOf.call(slides, beste.target);
        if (index >= 0) markiere(index);
      },
      { threshold: [0.25, 0.5, 0.75], rootMargin: '-20% 0px -20% 0px' }
    );

    for (var s = 0; s < slides.length; s++) beobachter.observe(slides[s]);

    // Klick auf ein Vorschaubild springt zum zugehörigen Bild.
    for (var k = 0; k < thumbs.length; k++) {
      (function (idx) {
        thumbs[idx].addEventListener('click', function () {
          if (slides[idx]) slides[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      })(k);
    }

    console.info('[RXK] Galerie-Scroll aktiv —', slides.length, 'Bilder');
  }

  // Horizon baut die Galerie neu auf, sobald der Konfigurator seine Vorschau
  // einhaengt oder eine Variante wechselt. Die selbst gebaute Vorschauspalte
  // geht dabei verloren - deshalb erneut aufbauen, sobald sie fehlt.
  function beobachte() {
    var warten;
    var laeuft = false;
    var versuche = 0;

    new MutationObserver(function () {
      clearTimeout(warten);
      warten = setTimeout(function () {
        if (laeuft || versuche > 5) return;
        var g = document.querySelector('media-gallery');
        if (g && g.querySelector('.media-gallery__grid') && !g.querySelector('.rxk-thumbs')) {
          laeuft = true;
          versuche++;
          start();
          setTimeout(function () { laeuft = false; }, 300);
        }
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Beides gehoert zusammen und lief frueher nur im else-Zweig: Wurde die Seite
  // noch geparst, blieb der Beobachter aus - und die Vorschauspalte kam nach
  // einem Variantenwechsel nicht wieder.
  function los() {
    start();
    beobachte();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }
})();
